function getCollapseInstance(modalEl: HTMLElement): bootstrap.Collapse {
    const instance = bootstrap.Collapse.getInstance(modalEl);
    if (instance) {
        return instance;
    }
    return new bootstrap.Collapse(modalEl, {toggle: false});
}

export function hideCollapse(modalEl: HTMLElement): void {
    getCollapseInstance(modalEl).hide();
}

export function showCollapse(modalEl: HTMLElement): void {
    const instance = getCollapseInstance(modalEl);
    instance.show();
}

export function toggleCollapse(modalEl: HTMLElement): void {
    getCollapseInstance(modalEl).toggle();
}
